import styled from "styled-components";

import { fieldHorizontalPadding } from "./styles";

const commonInputStyles = `
  // from bootstrap
  width: 100%;
  height: calc(1.5em + 0.75rem + 6px);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  padding: 8px 8px 8px ${fieldHorizontalPadding}px; // right padding less than left padding - looks better
  color: var(--husk);
  border: none;

  font-size: var(--textM);
  line-height: 1.5;
`;

export const ReadOnlyInput = styled.input`
  ${commonInputStyles}
  pointer-events: none;
  border-bottom: solid 1px var(--foam);
`;

const Input = styled.input<{ isInvalid?: boolean }>`
  ${commonInputStyles}
  border-radius: 8px;
  background-color: var(--cream);

  // Fixes issue with input box-shadow on ipad
  -webkit-appearance: none !important;

  &::placeholder {
    color: var(--rock);
  }

  &:focus {
    outline: 0;
    background-color: var(--white);
    border-color: #e2f5f4;
    box-shadow: 0 0 0 0.2rem rgba(131, 212, 208, 0.25);
  }

  ${(props) =>
    props.isInvalid &&
    `
  border: solid 2px var(--watermelon);

  &:focus {
    border-color: #ea526f;
    box-shadow: 0 0 0 0.2rem rgba(234, 82, 111, 0.25);
  }
  `}

  // Remove the up and down arrows that some browsers show for number input fields.
  // In case the browser doesn't remove them, have added the step attribute to the input
  // element, so the step is 1p rather than removing any entered pence value.
  appearance: textfield;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    appearance: none;
  }
`;

export default Input;
